import React from 'react';
import { CtaLink, Kicker } from './ui';
import { whatsappUrl } from '../../data/links';
import { IMAGES } from '../../data/vcars';
export function UrgencySection() {
  return <section className="relative overflow-hidden" data-id="element-134" data-mp="uti1vn574mln">
      <img src={IMAGES.interior} alt="Interior moderno de un vehículo" className="absolute inset-0 h-full w-full object-cover" data-id="element-135" data-mp="us6rv5l5qim3" />
      <div className="absolute inset-0 bg-[#08090b]/88" data-id="element-136" data-mp="24kpg0no1k0t" />

      <div className="relative mx-auto w-full max-w-6xl px-5 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-24" data-id="element-137" data-mp="252of51pqccf">
        <Kicker data-id="element-138" data-mp="3td8a0ee3137b">Oportunidad</Kicker>
        <h2 className="font-display mt-4 max-w-2xl text-3xl font-bold uppercase leading-[1.03] text-white sm:text-4xl lg:text-5xl" data-id="element-139" data-mp="c3jlmjr8vn6x">
          Las mejores unidades <span className="text-[#5b83ff]" data-id="element-140" data-mp="72m4mahz0z70">suelen durar poco</span>
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-141" data-mp="1ngud515wp7zn">
          Cuando aparece un auto con buen estado, precio competitivo y
          condiciones claras, normalmente se reserva rápido. Si ya estás
          buscando comprar o cambiar tu auto, escribinos hoy y te ayudamos a
          encontrar opciones disponibles.
        </p>
        <CtaLink href={whatsappUrl('Hola VCARS, quiero consultar las opciones disponibles ahora.')} label="Consultar opciones disponibles ahora" className="mt-8" data-id="element-142" data-mp="2bt8k0501l8pt" />
      </div>
    </section>;
}